<div class="min-h-full" style="background-color: #fafaf7;">

  @if (isLoading()) {
    <div class="flex items-center justify-center min-h-[60vh]">
      <div class="flex flex-col items-center gap-5">
        <div class="relative w-12 h-12">
          <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
          <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
        </div>
        <p class="text-stone-600 font-medium text-sm">Chargement…</p>
      </div>
    </div>
  }

  @if (!isLoading()) {
    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 py-8 space-y-6">

      <!-- Search -->
      <div class="bg-white rounded-3xl shadow-sm border border-stone-100 px-6 py-4">
        <div class="flex flex-wrap items-center gap-3">
          <div class="relative max-w-sm flex-1">
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
            </svg>
            <input type="search"
              class="w-full bg-white border border-stone-200 text-stone-800 placeholder-stone-400 text-sm rounded-lg pl-11 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              placeholder="Rechercher un album…"
              (input)="onSearch($any($event.target).value)" />
            @if (isFiltering()) {
              <div class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4">
                <div class="w-4 h-4 rounded-full border-2 border-stone-200 border-t-primary-400 animate-spin"></div>
              </div>
            }
          </div>
          <select
            class="bg-white border border-stone-200 text-stone-700 text-sm rounded-lg pl-3 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
            (change)="onStatusFilter($any($event.target).value)">
            <option value="">Tous les statuts</option>
            <option value="ACTI">En ligne</option>
            <option value="INAC">Hors ligne</option>
          </select>
          @if (permService.can('marketing', 'albums', 'create')) {
            <button (click)="onAddNew()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-xs font-medium flex-shrink-0 ml-auto">
              <span class="material-icons text-base">add</span>
              Ajouter un album
            </button>
          }
        </div>
      </div>

      <!-- Empty state -->
      @if (albums().length === 0) {
        <div class="flex flex-col items-center gap-3 py-24 text-center">
          <div class="w-14 h-14 rounded-3xl bg-stone-100 flex items-center justify-center">
            <span class="material-icons text-stone-300 text-3xl">photo_library</span>
          </div>
          <p class="text-stone-500 text-sm font-medium">Aucun album disponible</p>
          <p class="text-stone-400 text-xs">Créez votre premier album en cliquant sur "Ajouter un album"</p>
        </div>
      }

      <!-- Albums grid -->
      @if (albums().length > 0) {
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          @for (album of albums(); track album.id_media_library) {
            <div
              class="bg-white rounded-xl border border-stone-200 overflow-hidden hover:shadow-md hover:border-primary-200 transition-all duration-200 cursor-pointer group"
              (click)="onAlbumClick(album.id_media_library)">
              <!-- Thumbnail -->
              <div class="aspect-video bg-stone-100 flex items-center justify-center overflow-hidden relative">
                @if (album.file_link) {
                  <img [src]="album.file_link" aria-hidden="true" class="absolute inset-0 w-full h-full object-cover blur-sm scale-110 opacity-60" />
                  <img [src]="album.file_link" [alt]="album.title" class="relative z-10 h-full w-auto object-contain group-hover:scale-105 transition-transform duration-300" />
                } @else if (videoThumbnail(album.video_link)) {
                  <img [src]="videoThumbnail(album.video_link)!" aria-hidden="true" class="absolute inset-0 w-full h-full object-cover blur-sm scale-110 opacity-60" />
                  <img [src]="videoThumbnail(album.video_link)!" [alt]="album.title" class="relative z-10 h-full w-auto object-contain group-hover:scale-105 transition-transform duration-300" />
                } @else {
                  <span class="material-icons text-stone-300 text-5xl">photo_library</span>
                }
                @if (album.video_link) {
                  <span class="absolute top-2 right-2 flex items-center gap-1 bg-black/60 text-white text-[10px] font-semibold px-2 py-0.5 rounded-full">
                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M21.582 6.186a2.506 2.506 0 00-1.765-1.77C18.254 4 12 4 12 4s-6.254 0-7.817.416A2.506 2.506 0 002.418 6.186 26.5 26.5 0 002 12a26.5 26.5 0 00.418 5.814 2.506 2.506 0 001.765 1.77C5.746 20 12 20 12 20s6.254 0 7.817-.416a2.506 2.506 0 001.765-1.77A26.5 26.5 0 0022 12a26.5 26.5 0 00-.418-5.814zM10 15.464V8.536L16 12l-6 3.464z"/>
                    </svg>
                    Vidéo
                  </span>
                }
              </div>
              <!-- Info -->
              <div class="p-4 space-y-2">
                <p class="text-sm font-semibold text-stone-800 line-clamp-2 group-hover:text-primary-700 transition-colors">{{ album.title }}</p>
                <div class="flex items-center justify-between gap-2">
                  @if (album.event_date) {
                    <p class="text-xs text-stone-500">{{ formatDate(album.event_date) }}</p>
                  }
                  <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold border shrink-0"
                    [class]="album.status === 'ACTI'
                      ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
                      : 'bg-amber-50 text-amber-700 border-amber-200'">
                    <span class="w-1.5 h-1.5 rounded-full"
                      [class]="album.status === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'"></span>
                    {{ album.status_label || (album.status === 'ACTI' ? 'En ligne' : 'Hors ligne') }}
                  </span>
                </div>
                <app-tag-chips [value]="album.media_tags" [max]="2"></app-tag-chips>
              </div>
            </div>
          }
        </div>

        <!-- Pagination -->
        @if (totalPages() > 1) {
          <div class="flex items-center justify-center gap-3 pt-4">
            <button (click)="goToPage(currentPage() - 1)" [disabled]="!hasPrevPage()"
              class="px-4 py-2 rounded-lg text-sm font-medium border border-stone-200 bg-white text-stone-700 hover:bg-stone-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              Précédente
            </button>
            <span class="text-sm text-stone-500">{{ currentPage() }} / {{ totalPages() }}</span>
            <button (click)="goToPage(currentPage() + 1)" [disabled]="!hasNextPage()"
              class="px-4 py-2 rounded-lg text-sm font-medium border border-stone-200 bg-white text-stone-700 hover:bg-stone-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              Suivante
            </button>
          </div>
        }
      }

    </div>
  }
</div>
